import { AppBar, Box, Tab, Tabs, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { getDataInLocalstorage } from "common/method/getDataInLocalstorage";
import PropTypes from "prop-types";
import { useEffect, useMemo, useState } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { useMouse } from "rooks";
import { FadeInt3Div } from "styledComponents/animation";
import LoginPass from "./tamplet/index";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component={"div"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",

    fontFamily: "IRANSansWeb_Farsi !important",
  },
  tabBar: {
    backgroundColor: "#fff !important",
    boxShadow: "none !important",
  },
  tabBarLable: {
    color: "#099C55",
    // borderBottom: "2px solid #099C55",
    display: "flex",
    justifyContent: "center",
  },
  tabPanel: {
    fontWeight: 900,
    fontSize: "14px !important",
    "@media (min-width:991px) and (max-width:1400px)": {
      minWidth: "101px !important",
    },
  },
  paddingNone: {
    padding: "0 !important",
    "& > div": {
      padding: "0",
    },
  },
  bold: {
    fontWeight: 600,
    fontSize: 15,
  },
  GreenBold: {
    fontSize: 15,
    fontWeight: 600,
    color: "#099C55",
  },
  box: {
    width: 500,
    "@media (min-width:100px) and (max-width:350px)": {
      width: 310,
    },
    "@media (min-width:351px) and (max-width:420px)": {
      width: 350,
    },
  },
}));
function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

const ChangePasswordForm = () => {
  const location = useLocation();
  let query = useQuery();
  const [utmQuery, setUtmQuery] = useState(undefined);
  useEffect(() => {
    setUtmQuery(query.get("id"));
  }, [query]);

  const classes = useStyles();

  const [value, setValue] = useState(0);
  const [flagLogin, setflagLogin] = useState(0);
  const info = useMouse();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const user = getDataInLocalstorage();
  let token = user?.token;
  let member_id = user?.member_id;

  if (token?.authToken && member_id && location.pathname === "/auth") {
    return <Redirect from="/" to="/home" />;
  }

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0px auto",
        height: "100%",
        flexDirection: "column",
      }}
    >
      <div
        className={`${classes.box} bg-white rounded-lg shadow-xl flex justify-center px-4 md:px-8 content-center align-middle`}
      >
        <div className={`${classes.root}`}>
          <h2
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "bold",
              padding: 16,
            }}
          >
            تغییر رمز عبور
          </h2>{" "}
          <FadeInt3Div>
            <LoginPass setflagLogin={setflagLogin} flagLogin={flagLogin} />
          </FadeInt3Div>
        </div>
      </div>
      <div
        style={{
          marginBlock: "16px",
          padding: "16px",
          backgroundColor: "#c6e2ff",
          borderRadius: "8px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          color: "#333",
          lineHeight: "1.8",
          fontSize: "14px",
          maxWidth: "500px",
        }}
      >
        <h3
          style={{
            fontWeight: "bold",
            marginBottom: "8px",
            color: "#099C55",
            fontSize: "16px",
          }}
        >
          نکات مهم:
        </h3>
        <ul style={{ paddingLeft: "20px" }}>
          <li>
            رمز عبور شما باید شامل <strong>حداقل ۸ کاراکتر</strong> و دارای{" "}
            <strong>حروف کوچک و بزرگ انگلیسی</strong> و <strong>یک عدد</strong>{" "}
            باشد.
          </li>
          <li>تکرار رمز عبور برای تأیید صحت آن الزامی است.</li>
          <li>
            حتماً <strong>کد کپچا</strong> و <strong>کد امنیتی</strong> را
            به‌درستی وارد کنید.
          </li>
          <li>
            از رمزهای عبور ساده و قابل حدس خودداری کنید. امنیت حساب شما برای ما
            اهمیت بالایی دارد.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ChangePasswordForm;
